import { PreProcessor, appendParams } from 'api/requestUtils'

export default function brandLoader(brand: string): PreProcessor {
  return (params) => {
    const { path, options } = params

    if (
      options.excludeBrand ||
      path.includes('without_brand=1') ||
      path.includes('/api/trips') ||
      path.includes('/api/search/place/v1/places') ||
      path.includes('business-traveller/employee') ||
      path.includes('business-traveller/request-demo') ||
      path.includes('business-traveller/businesses/email-or-domain-exists') ||
      path.includes('rate-plans/surcharge-dates/margin')
    ) {
      return params
    }

    appendParams({
      key: 'brand',
      value: brand,
    }, params)
    return params
  }
}
